








import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

@Component
export default class StaticticChart extends Vue {
  @Prop({ default: 'row' }) private direction !: string
  @Prop({ default: 'center' }) private justify !: string
  @Prop({ default: 'center' }) private alignment !: string
  @Prop({ default: '' }) private icon !: string
  @Prop({ default: '' }) private title !: string
  @Prop({ default: '' }) private subtitle !: string
  @Prop({ default: 'md' }) private size !: string

  private sizeToNumber() {
    switch (this.size) {
      case 'xs': return 1.5
      case 'sm': return 2.25
      case 'md': return 3
    }
  }
}
